/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
*/
import Request from 'generic/request/Request'

const LOGIN_URL = '/api/login/'
const CONNECTED_USER_URL = '/api/connected/user/'
const USER_URL = '/api/user/'
const USER_VALIDATION_URL = '/api/user/validation/'
export const USER_LIST_URL = '/api/user/list/'
const USER_TYPE_VIEW_LIST = '/api/user/type/view/list/'

export function getUserTypeViews() {
  return Request.getRequest(USER_TYPE_VIEW_LIST)
}

export function updatePassword (user, password) {
  return Request.getRequest(CONNECTED_USER_URL)
    .then((result) => {
      let url = USER_URL + result.data.object.uid + '/'

      if (user) {
        url = USER_URL + user.uid + '/'
        user.password = password
      } else {
        user = {
          password: password,
          username: result.data.object.username
        }
      }

      return Request.postRequest(url, user)
    })
    .then(() => {
      if (!user) {
        return Request.postRequest(LOGIN_URL, user)
      }
    })
}

export function getUser(uid) {
  return Request.getRequest(USER_URL + (uid ? uid+ '/' : ''))
    .then((result) => {
      return result.data.object
    })
}

export function postUserValidation(data, uid) {
  return Request.postRequest(USER_VALIDATION_URL + (uid ? uid+ '/' : ''), data)
    .then((result) => {
      return result.data.object
    })
}

export function postUser(data, uid) {
  return Request.postRequest(USER_URL + (uid ? uid+ '/' : ''), data)
    .then((result) => {
      return result.data.object
    })
}




// WEBPACK FOOTER //
// ./src/actions/User.js